import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, map, catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  private readonly apiUrl = `${environment.apiUrl}/Upload/Deal`;

  constructor(private http: HttpClient) {}

  uploadImage(file: File): Observable<{ id: number, url: string }> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<{ success: boolean, data: { id: number, url: string }, error: any }>(
      this.apiUrl,
      formData
    ).pipe(
      map(res => {
        if (!res.success) {
          let message = 'UNKNOWN_ERROR';
          if (res.error && Array.isArray(res.error)) {
            message = res.error[0];
          } else if (res.error?.message) {
            message = res.error.message;
          }
          throw new Error(message);
        }
        return res.data;
      }),
      catchError((err: any) => {
        let errorMessage = 'UNKNOWN_ERROR';

        if (err instanceof HttpErrorResponse) {
          if (err.error && Array.isArray(err.error)) {
            errorMessage = err.error[0];
          } else if (err.error?.error && Array.isArray(err.error.error)) {
            errorMessage = err.error.error[0];
          } else if (err.error?.message) {
            errorMessage = err.error.message;
          }
        } else if (err instanceof Error) {
          errorMessage = err.message;
        }

        return throwError(() => errorMessage);
      })
    );
  }

  deleteImage(id: number): Observable<any> {
    // API endpoint for delete is not provided yet, but keeping the method
    return new Observable(obs => obs.next(true));
  }
}
